import * as React from 'react';
import {Component} from 'react';
import {observer} from 'mobx-react';
import classNames from 'classnames';
import {toggleExpanded} from '../../../_legacy/Screens/Common/actions/Collection';
import {
    withElementRef,
    InjectedElementRefProps
} from '../../../_legacy/components/Fields/withElementRef';
import CollapsibleField, {CollapsibleFieldProps} from './Field';

export interface InjectedParentFieldProps extends CollapsibleFieldProps {
    isExpanded: boolean;
    toggleExpanded(): void;
    isParent: boolean;
}

@observer
class Collection extends Component<CollapsibleFieldProps & InjectedElementRefProps, null> {
    constructor(props) {
        super(props);

        this.toggleExpanded = this.toggleExpanded.bind(this);
    }

    toggleExpanded() {
        const {field, elementRef} = this.props;
        const {isExpanded} = field.collection;

        toggleExpanded(field.collection);

        if (!isExpanded && elementRef.current) {
            // check what does the following mean:
            // 'When we deactivate a tab, if its parent is already selected we don't want to scroll it (the parent) into view.'
            setTimeout(
                () =>
                    elementRef.current.scrollIntoView({
                        block: 'start',
                        inline: 'nearest',
                        behavior: 'smooth'
                    }),
                0
            );
        }
    }

    render() {
        const {field, depth = 0, renderParent: ParentField} = this.props;
        const {elementRef, ...propsWithoutElementRef} = this.props;
        const {isExpanded, fields} = field.collection;

        const collectionClass = classNames('tab-fields', {
            shrinked: !isExpanded,
            expanded: isExpanded
        });

        return (
            <div ref={elementRef}>
                <ParentField
                    {...propsWithoutElementRef}
                    isExpanded={isExpanded}
                    toggleExpanded={this.toggleExpanded}
                    isParent
                />
                <div className={collectionClass}>
                    {isExpanded &&
                        fields.map(f => (
                            <CollapsibleField
                                key={f.name}
                                {...propsWithoutElementRef}
                                field={f}
                                depth={depth + 1}
                            />
                        ))}
                </div>
            </div>
        );
    }
}

const CollapsibleCollection = withElementRef(Collection);
export default CollapsibleCollection;
